// const HEARTBEAT_TOPIC = ['volume', 'motion', 'language'];

import { action, observable } from 'mobx';

const MAX_WAITING_TIME = 10; //ack response max waiting time (in seconds)
const ACTIVE_HEARTBEAT_TIMEOUT = 15;
const INACTIVE_HEARTBEAT_TIMEOUT = 150;

const LikuHeartBeat = (
	isMqttClientState,
	// isContentsLoading,
	// isContentsStart,
) => {
	const acks = [];

	let isHeartBeat = observable.box(false);
	let isConnectionFailed = observable.box(false);
	let heartBeat = 0;
	let heartBeatTimeout = null;
	let heartBeatInterval = null;

	// let isMqttClientState = () => false;
	let isContentsLoading = () => false;
	let isContentsStart = () => false;
	let isContentsPaused = () => false;

	const setHandlers = (handlers, startHandler, pausedHandler) => {
		const loadingFn =
			typeof handlers === 'function' ? handlers : handlers?.isContentsLoading;
		const startFn =
			typeof startHandler === 'function'
				? startHandler
				: handlers?.isContentsStart;
		const pausedFn =
			typeof pausedHandler === 'function'
				? pausedHandler
				: handlers?.isContentsPaused;

		isContentsLoading = loadingFn ?? isContentsLoading;
		isContentsStart = startFn ?? isContentsStart;
		isContentsPaused = pausedFn ?? isContentsPaused;
	};

	const shouldRespondToHeartbeat = () => isMqttClientState();

	const getCurrentDate = () => {
		const currentDate = new Date();
		return `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}:${currentDate.getMilliseconds()}`;
	};

	const setIsHeartBeat = action((value = true) => {
		// isHeartBeat = value;
		isHeartBeat.set(value);
		isConnectionFailed.set(!value);
		console.log('setIsHeartBeat', isHeartBeat.get());
	});

	const setHeartBeat = () => {
		console.log(`setHeartBeat !! ${getCurrentDate()}`);
		heartBeat = 0;
		setIsHeartBeat(true);
		setHeartBeatInterval();
	};

	const setHeartBeatInterval = () => {
		if (heartBeatInterval) return;

		console.log(`setHeartBeatInterval START !! ${getCurrentDate()}`);
		heartBeatInterval = setInterval(() => {
			if (!isMqttClientState()) {
				acks.splice(0, acks.length);
				setIsHeartBeat(false);
				clearInterval(heartBeatInterval);
				heartBeatInterval = null;
				return;
			}

			const shouldMonitorHeartbeat =
				(isContentsStart() || isContentsPaused()) && !isContentsLoading();
			const nextHeartBeatTimeout = shouldMonitorHeartbeat
				? ACTIVE_HEARTBEAT_TIMEOUT
				: INACTIVE_HEARTBEAT_TIMEOUT;

			if (heartBeatTimeout !== nextHeartBeatTimeout) {
				heartBeat = 0;
				heartBeatTimeout = nextHeartBeatTimeout;
			}

			if (!shouldMonitorHeartbeat) {
				acks.splice(0, acks.length);
			}

			heartBeat += 1;
			if (heartBeat >= heartBeatTimeout) {
				console.log(`heartbeat clearInterval !!! ${getCurrentDate()}`);
				acks.splice(0, acks.length);
				setIsHeartBeat(false);
				clearInterval(heartBeatInterval);
				heartBeatInterval = null;
				return;
			}

			if (shouldMonitorHeartbeat) checkAck();
		}, 1000);
	};

	// const getTopicType = (topic) => {
	// 	return HEARTBEAT_TOPIC.find((value) => topic.includes(value));
	// };

	const checkAck = () => {
		const current_time = new Date();
		acks.forEach((obj) => {
			console.log('checkAck', obj);
			if (
				current_time.getTime() / 1000 - obj.date.getTime() / 1000 >=
				MAX_WAITING_TIME
			) {
				console.log('checkAck False!!!!');
				setIsHeartBeat(false);
				acks.splice(0);
			}
		});
	};

	const addAck = (type) => {
		// const type = getTopicType(topic);
		if (type) {
			acks.push({ type, date: new Date() });
			console.log('acks last data', acks[acks.length - 1]);
		}
	};

	const popAck = (type) => {
		// const type = getTopicType(topic);

		const index = acks.findIndex((ack) => ack.type === type);
		if (index !== -1) {
			const a = acks.splice(index, 1);
			console.log('popAck', a);
		}
	};

	return {
		get isHeartBeat() {
			return isHeartBeat.get();
		},
		get isConnectionFailed() {
			return isConnectionFailed.get();
		},
		heartBeat,
		// getCurrentDate,
		setHandlers,
		shouldRespondToHeartbeat,
		setIsHeartBeat,
		setHeartBeat,
		setHeartBeatInterval,
		checkAck,
		addAck,
		popAck,
	};
};

export default LikuHeartBeat;
